import useNetwork from '@/hooks/useNetwork';

export default function useNetworkFilter() {
  const network = useNetwork();

  return {
    evaluationProjectEducator: network?.id ? {
      $where: {
        project: {
          $where: {
            networkId: network.id
          }
        }
      }
    } : undefined
  };
};
